// this needs to be the first import since it determines the cdn location of resources
import "./publicPath.ts";

import * as Sentry from "@sentry/browser";
import "./helpers/nodelist-foreach-polyfill";
import "./i18n/i18n";
import {RootBannerSection} from "./components/swipers/rootBannerSection";
import {TeaserSwiper, TeaserSwiperRedesign} from "./components/swipers/teaserSlider";
import {BlogImageSwiper} from "./components/swipers/blogImageSwiper";
import {ProductSwiper} from "./components/swipers/productSwiper";
import {BlogGallerySwiper} from "./components/swipers/blogGallerySwiper";
import {BwareSwiper} from "./components/swipers/bwareSwiper";
import {ShopRatingHandler} from "./components/ShopRating/shopRatingHandler";
import PinitComponent from "./components/pinitComponent";
import {init as initCart} from "./index-cart";
import EnergyLabelPortal from "./components/energyLabel/EnergyLabelPortal";
import NewsletterRegistrationPagePortal from "./components/newsletter/NewsletterRegistrationPagePortal";
import {ProductBundleHandler} from "./components/ProductView/PdpBundle";
import {beforeBreadcrumb, beforeSend} from "./helpers/sentryHelper";
import TopCategories from "./components/categories/TopCategories";
import BlogOverviewSwiper from "./components/organisms/blog/BlogOverviewSwiper";
import HomepageBannerSwiper from "./components/organisms/homepageBannerSlider/HomepageBannerSwiper";
import {AdvantageBannerSwiper, AdvantageBannerSwiperRedesign} from "./components/swipers/advantageBannerSwiper";
import PayPalPayLaterMessagePortal from "./components/lib/Banner/PayPalPayLaterMessage";
import SubNavImageLinkPortal from "./components/molecules/SubNavImageLink";
import GiftBlockPortal from "./components/giftBlock/GiftBlockPortal";

Sentry.init({
  dsn: "https://17a766be243d431cb89d9487d11259fe@sentry.io/1299670",
  enabled: __PRODUCTION__ || !!new URLSearchParams(window.location.search).get("sentry"),
  normalizeDepth: 5,
  beforeBreadcrumb,
  beforeSend,
});

if (__DEVELOPMENT__) {
  // eslint-disable-next-line no-console
  console.log("%cDevelopment", "color: red; font-size: x-large;");
}

initCart();

// Initialisierung Swiper Homepage
const bannerSection: HTMLElement | null = document.getElementById("BannerSection");
if (bannerSection !== null) {
  new RootBannerSection(bannerSection);
}

// Product slider in blog entries and in longtext (TextPlaceholder)
const swiperProducts: NodeListOf<HTMLDivElement> | null = document.querySelectorAll(".swiper-products");
const swiperProductsRedesign: NodeListOf<HTMLDivElement> | null =
  document.querySelectorAll(".swiper-products-redesign");

if (swiperProducts.length > 0) {
  swiperProducts.forEach((swiper) => {
    new TeaserSwiper(swiper);
  });
}
if (swiperProductsRedesign.length > 0) {
  swiperProductsRedesign.forEach((swiper) => {
    TeaserSwiperRedesign.run(swiper);
  });
}

// Mobiler Vorteile Banner Slider
const swiperAdvantageBanner: HTMLElement | null = document.querySelector("#AdvantageBannerSwiper");
const swiperAdvantageBannerRedesign: HTMLElement | null = document.querySelector("#AdvantageBannerSwiperRedesign");
if (swiperAdvantageBanner) {
  new AdvantageBannerSwiper(swiperAdvantageBanner);
}
if (swiperAdvantageBannerRedesign) {
  AdvantageBannerSwiperRedesign.run(swiperAdvantageBannerRedesign);
}

// Blog images, Coverflow style
const swiperBlogImages: NodeListOf<HTMLDivElement> = document.querySelectorAll(".swiper-blog-images");
if (swiperBlogImages.length > 0) {
  swiperBlogImages.forEach((swiper) => {
    new BlogImageSwiper(swiper);
  });
}

// Initialisierung Swiper Produktseiten
const swiperContainerProduct: Element = document.getElementsByClassName("swiper-container-product")[0];
const zoomAnchorList: HTMLCollectionOf<Element> = document.getElementsByClassName("gallery-zoom");
if (swiperContainerProduct !== null) {
  new ProductSwiper(swiperContainerProduct, zoomAnchorList);
}

// Initialisierung Swiper Blog-Einträge - Galerie
const gallerySwiper: HTMLDivElement | null = document.querySelector(".swiper-container-gallery");
if (gallerySwiper !== null) {
  new BlogGallerySwiper(gallerySwiper);
}

// Alle Swiper B-Waren-Seite
const galleryLinkCollection = document.querySelectorAll<HTMLAnchorElement>(".gallery-link");
if (galleryLinkCollection.length > 0) {
  galleryLinkCollection.forEach((anchor) => {
    new BwareSwiper(anchor);
  });
}

// Asynchronous shoprating loading
const shopRatingElement: HTMLElement | null = document.querySelector("[data-react-rating]");
const headlineRating: HTMLElement | null = document.querySelector(".product-rating");
if (shopRatingElement) {
  ShopRatingHandler.run(shopRatingElement, headlineRating);
}

const blogEntryContentElement = document.querySelector<HTMLElement>(".blog-entry__content");
if (blogEntryContentElement) {
  PinitComponent.pinit(blogEntryContentElement);
}

const newsletterRegistrationPage = document.getElementById("newsletter-landing-page");
if (newsletterRegistrationPage) {
  NewsletterRegistrationPagePortal.run(newsletterRegistrationPage);
}

const energyLabelElements = document.querySelectorAll<HTMLElement>("[data-energy-class]");
if (energyLabelElements.length) {
  EnergyLabelPortal.run(energyLabelElements);
}

const productBundleContainer = document.getElementById("product-bundle-container");
if (productBundleContainer) {
  ProductBundleHandler.run(productBundleContainer as HTMLDivElement);
}

const topCategory: HTMLElement | null = document.querySelector("#topCategoriesPlaceholder");
if (topCategory) {
  TopCategories.run(topCategory);
}

const rootBlogOverviewSection: HTMLElement | null = document.querySelector("#blogOverviewPlaceholder");
if (rootBlogOverviewSection) {
  BlogOverviewSwiper.run(rootBlogOverviewSection);
}

const redesignHomepageBannerSection: HTMLElement | null = document.querySelector("#BannerSectionRedesign");
if (redesignHomepageBannerSection) {
  HomepageBannerSwiper.run(redesignHomepageBannerSection);
}

PayPalPayLaterMessagePortal.run();

SubNavImageLinkPortal.run();

const giftBlockContainer: HTMLDivElement | null = document.querySelector("#ProductGiftBlock");
if (giftBlockContainer) {
  GiftBlockPortal.run(giftBlockContainer);
}
